module.exports = "https://img.zhijierongxing.com/saas/img/toppic.09fbf38e.png";